export const formatSeconds = seconds =>
  new Date(new Date(null).setSeconds(seconds)).toISOString().substr(11, 8);
